import { Switch, Route } from "react-router-dom";
import "./App.scss";
import "antd/dist/antd.css";

// pages import

import { useState } from "react";

import InternalScreens from "./screens/internal-screens";
import ExternalScreens from "./screens/external-screens";
function App() {
  const [login, setLogin] = useState(true);

  return (
    <div className="App">
      <Switch>
        {login ?  <Route path="/screens" component={InternalScreens} />: null}
        {/* <Route path="/screens" component={InternalScreens} /> */}
        <Route path="/" component={ExternalScreens} />
      </Switch>
    </div>
  );
}

export default App;
